import DocumentCropPopupContainer from './DocumentCropPopupContainer';

export default DocumentCropPopupContainer;